import React from 'react';
import styled from 'styled-components';
import { fontStyle, themeLight, spacing } from '@naf/theme';
import { Error } from '@styled-icons/material/Error';
export const Message = ({
  children,
  error = true,
  className
}) => {
  return /*#__PURE__*/React.createElement(FormMessage, {
    className: className,
    error: error
  }, error && /*#__PURE__*/React.createElement(Error, {
    size: 16
  }), children);
};
export default Message;
const FormMessage = styled.span.withConfig({
  displayName: "message__FormMessage",
  componentId: "sc-1mqvlfe-0"
})(["", ";flex-basis:100%;display:flex;align-items:center;color:", ";svg{padding-right:", ";}"], fontStyle.bodyText.small, ({
  theme
}) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error, spacing.space8);
//# sourceMappingURL=message.js.map